<template>
  <div style="position: relative;">
    <AGCRadioGroup
            v-model="questionItem.questionType"
            name="問題"
            :options="questionTypeOptions"
            :disabled="readOnly"
            :label="questionOrderTag(questionIndex)"
            @change="handleClearInput"
          >
    </AGCRadioGroup>

      <b-button class="btn--add-question" :variant="'outline-primary'"
        :disabled="readOnly" @click="deleteQuestion(questionIndex)"
      >
        -刪除
      </b-button>
    <AGCSelectGroup
      v-if="questionItem.questionType === 'default'"
      v-model="questionItem.question"
      :options="questionOptions"
      :disabled="readOnly"
      rules="required"
      :name="'問題' + (questionIndex + 1)"
    ></AGCSelectGroup>
      <b-col md="12" class="mb-3">
        <AGCInput
          v-if="questionItem.questionType === 'customized'"
          v-model.trim="questionItem.question"
          :id="'question' + (questionIndex + 1)"
          :name="'問題' + (questionIndex + 1)"
          rules="required|maxWord:50"
          class="mb-3"
          placeholder="輸入問題"
          required
          :disabled="readOnly"
        ></AGCInput>
      </b-col>
      <b-col md="12" class="mb-3">
        <AGCInput
          v-model.trim="questionItem.hints"
          :id="'hints' + (questionIndex + 1)"
          :name="'提示' + (questionIndex + 1)"
          rules="maxWord:50"
          class="mb-3"
          placeholder="可輸入答案提示"
          required
          :disabled="readOnly"
        ></AGCInput>
      </b-col>
      <b-col md="12" class="mb-3 category-tags">
        <AGCCheckbox v-model="questionItem.compulsory"
        :disabled="readOnly">
          買家必須填寫
        </AGCCheckbox>
      </b-col>
  </div>
</template>

<script>
import AGCRadioGroup from '@/components/form/AGCRadioGroup.vue';
import AGCSelectGroup from '@/components/form/AGCSelectGroup.vue';
import AGCInput from '@/components/form/AGCInput.vue';
import AGCCheckbox from '@/components/form/AGCCheckbox.vue';
import {
  BCol,
  BButton,
} from 'bootstrap-vue';
import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

export default {
  mixins: [formMixin, vModelMixin],
  components: {
    AGCRadioGroup,
    AGCSelectGroup,
    AGCInput,
    AGCCheckbox,
    BCol,
    BButton,
  },
  props: {
    question: {
      type: Object,
    },
    questionIndex: {
      type: Number,
      default: 1,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    questionItem: {},
    questionTypeOptions: [],
    questionOptions: [],
  }),
  computed: {

  },
  watch: {
    questionItem: {
      handler(val) {
        this.$emit('update', val);
      },
      deep: true,
    },
    // resume question value back to un-edit stage
    question: {
      handler(val) {
        this.questionItem = val;
      },
      deep: true,
    },
    'questionItem.compulsory': function () {
      this.questionItem.compulsory = Boolean(this.questionItem.compulsory);
    },
  },
  methods: {
    handleQuestionType() {
      this.questionTypeOptions = [
        { text: '預設問題', value: 'default' },
        { text: '自定問題', value: 'customized' },
      ];
    },
    handleDefaultQuestion() {
      this.questionOptions = [
        { text: '選擇預設問題', value: null },
        { text: '請輸入收貨地址', value: '請輸入收貨地址' },
        { text: '請輸入電話號碼', value: '請輸入電話號碼' },
      ];
    },
    questionOrderTag(index) {
      const q = '問題';
      return q.concat((index + 1).toString());
    },
    deleteQuestion(val) {
      this.$emit('delete', val);
    },
    handleClearInput() {
      this.questionItem.question = null;
      this.questionItem.hints = null;
      this.questionItem.compulsory = false;
    },
  },
  mounted() {
    this.handleQuestionType();
    this.handleDefaultQuestion();
    // fix props data is not completed
    this.questionItem = this.question;
  },
};
</script>

<style lang="scss" scoped>
label + #keyword-filter {
  input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.custom-date{
  display:inline-block !important;
}
.sub-label {
  // float: right;
  font-size: 14px;
  color: #7e8b97;
  font-weight: 400;
  padding-left: 5px;
}

.btn--add-question {
  top: 17%;
  font-size: 14px;
  font-weight: 400;
  border-style: none;
  position: absolute;
  right: 2%;
}

// hints style
.col-md-12 {
  padding-left: 0%;
  padding-right: 0%;
}
.btn {
  .btn-outline-primary {
    border-color: none !important;
  }
}
::v-deep.desc{
    img {
        max-width: 100% !important;
      }
  }
</style>
